module.exports = __webpack_public_path__ + "bb9e2e689bdb907731c64c5908295e40.png";